import axios from 'axios';

const RECOMMENDATION_API_URL = process.env.REACT_APP_RECOMMENDATION_API_URL || 'http://localhost:8080';

/**
 * Service to interact with the recommendation backend APIs
 */
const recommendationService = {
  /**
   * Get quiz questions from the backend
   */
  getQuizQuestions: async () => {
    try {
      const response = await axios.get(`${RECOMMENDATION_API_URL}/quiz/questions`);
      return response.data;
    } catch (error) {
      console.error('Error fetching quiz questions:', error);
      throw error;
    }
  },

  /**
   * Submit quiz answers for evaluation
   */
  evaluateQuizAnswers: async (answers) => {
    try {
      const response = await axios.post(`${RECOMMENDATION_API_URL}/quiz/evaluate`, {
        answers,
        siteKey: 'main'
      });
      return response.data;
    } catch (error) {
      console.error('Error evaluating quiz answers:', error);
      throw error;
    }
  },

  /**
   * Generate recommendations based on user profile and quiz answers
   */
  generateRecommendations: async (userData) => {
    try {
      const response = await axios.post(`${RECOMMENDATION_API_URL}/recommendations/generate`, {
        ...userData,
        siteKey: 'main'
      });
      return response.data;
    } catch (error) {
      console.error('Error generating recommendations:', error);
      throw error;
    }
  },

  /**
   * Filter products based on various criteria
   */
  filterProducts: async (filters) => {
    try {
      const response = await axios.get(`${RECOMMENDATION_API_URL}/products`, {
        params: {
          ...filters,
          siteKey: 'main'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error filtering products:', error);
      throw error;
    }
  }
};

export default recommendationService;